module.exports = __webpack_public_path__ + "89af39c086b2d7fc3dd040fea05ad977.png";